module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.notifications), function(n, index) {
    return _c('md-notification', {
      key: n,
      attrs: {
        "message": n.message,
        "icon": n.icon,
        "type": n.type,
        "placement": n.placement,
        "timeout": n.timeout,
        "allowDismiss": n.allowDismiss
      },
      on: {
        "onClose": function($event) {
          _vm.removeNotification(index)
        }
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf7df61e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdNotifications/index.vue
// module id = 5zX3
// module chunks = 13 14